<form class="ag-filter-wrapper ag-focus-managed">
    <div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper" ref="eFilterBody" style="flex: 0 0 auto; max-height: 745.219px">
        <div class="ag-filter-body" role="presentation" aria-hidden="false">
            <div
                role="presentation"
                class="ag-labeled ag-label-align-left ag-text-field ag-input-field ag-filter-from ag-filter-filter"
                aria-hidden="false"
                style="display: flex; flex-direction: column; align-items: flex-start; width: 100%"
            >
                <!-- <div class="ag-input-field-input ag-text-field-input"> -->
                <ng-container>
                    <mat-chip-grid #chips class="tt-search-multi-select__mat-chip-grid">
                        <mat-chip-row *ngFor="let id of selectedNames" class="tt-search-multi-select__mat-chip-row" (removed)="remove(id, auto)">
                            {{ id }}
                            <button matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + id">
                                <span class="far fa-times"></span>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
                        <input
                            class="ag-input-field-input ag-text-field-input tt_chip_filter_input"
                            #inputRef
                            #chipInput="matChipInput"
                            [formControl]="searchControl"
                            [matChipInputFor]="chips"
                            [matAutocomplete]="auto"
                        />
                        <!-- (optionSelected)="selected($event)" -->
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" hideSingleSelectionIndicator autoActiveFirstOption multiple class="ag-custom-component-popup">
                            <mat-option *ngFor="let item of data | async" [id]="item" class="tt-listbox__item ag-custom-component-popup" [value]="item">
                                <span>{{ item }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </ng-container>
                <!-- </div> -->
            </div>
        </div>
        <div class="ag-resizer-wrapper">
            <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
            <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
            <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
            <div ref="eRightResizer" class="ag-resizer ag-resizer-right" style="pointer-events: all"></div>
            <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight" style="pointer-events: all"></div>
            <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom" style="pointer-events: all"></div>
            <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
            <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
        </div>
    </div>
    <div class="ag-filter-apply-panel">
        <button type="button" ref="clearFilterButton" class="ag-button ag-standard-button ag-filter-apply-panel-button" (click)="clearFilter()">{{ clearFilterText }}</button>
    </div>
</form>
